module.exports = __webpack_public_path__ + "img/good6.b8c6d18f.png";